/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfUserOrderRateAdminListedDto } from '../models/Pagination1OfUserOrderRateAdminListedDto';
import type { Pagination1OfUserOrderRateClientListedDto } from '../models/Pagination1OfUserOrderRateClientListedDto';
import type { Pagination1OfUserOrderRateOperatorListedDto } from '../models/Pagination1OfUserOrderRateOperatorListedDto';
import type { PostOrderRateRequestClient } from '../models/PostOrderRateRequestClient';
import type { UserOrderRateClientDto } from '../models/UserOrderRateClientDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserOrderRatesService {
    /**
     * Gets branch order ratings. Repeat `branchRates` to filter by multiple ratings.
     * @returns Pagination1OfUserOrderRateOperatorListedDto OK
     * @throws ApiError
     */
    public static getUserOrderRatesOperator({
        branchId,
        branchRates,
        referenceCode,
        fromDate,
        toDate,
        hasComment,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId: number,
        /**
         * Optional branch-rating filter. Repeat `branchRates` for each rating; every value must be from 1 through 5.
         */
        branchRates?: Array<number>,
        referenceCode?: string,
        fromDate?: string,
        toDate?: string,
        hasComment?: boolean,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfUserOrderRateOperatorListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/userorderrates/{branchId}',
            path: {
                'branchId': branchId,
            },
            query: {
                'branchRates': branchRates,
                'referenceCode': referenceCode,
                'fromDate': fromDate,
                'toDate': toDate,
                'hasComment': hasComment,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserOrderRateClientDto OK
     * @throws ApiError
     */
    public static getOrderRateClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<UserOrderRateClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/userorderrates/{orderId}/rate',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserOrderRateClientDto OK
     * @throws ApiError
     */
    public static postOrderRateClient({
        orderId,
        requestBody,
    }: {
        orderId: string,
        requestBody?: PostOrderRateRequestClient,
    }): CancelablePromise<UserOrderRateClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/userorderrates/{orderId}/rate',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfUserOrderRateClientListedDto OK
     * @throws ApiError
     */
    public static getPublicOrderRatesClient({
        branchId,
        hasComment,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId: number,
        hasComment?: boolean,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfUserOrderRateClientListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/userorderrates/public',
            query: {
                'branchId': branchId,
                'hasComment': hasComment,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postIgnoreOrderRateClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/userorderrates/{orderId}/ignore',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUserOrderRates`
     * @returns Pagination1OfUserOrderRateAdminListedDto OK
     * @throws ApiError
     */
    public static getUserOrderRatesAdmin({
        driverCommentSearch,
        branchCommentSearch,
        onlyCommentsReturned,
        orderId,
        userId,
        userOrderRateReasonId,
        referenceCode,
        branchId,
        regionId,
        driverId,
        fromDate,
        toDate,
        page,
        limit,
    }: {
        driverCommentSearch?: string,
        branchCommentSearch?: string,
        onlyCommentsReturned?: boolean,
        orderId?: string,
        userId?: string,
        userOrderRateReasonId?: number,
        referenceCode?: string,
        branchId?: number,
        regionId?: number,
        driverId?: number,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfUserOrderRateAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/userorderrates',
            query: {
                'driverCommentSearch': driverCommentSearch,
                'branchCommentSearch': branchCommentSearch,
                'onlyCommentsReturned': onlyCommentsReturned,
                'orderId': orderId,
                'userId': userId,
                'userOrderRateReasonId': userOrderRateReasonId,
                'referenceCode': referenceCode,
                'branchId': branchId,
                'regionId': regionId,
                'driverId': driverId,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserOrderRates`
     * @returns any OK
     * @throws ApiError
     */
    public static approveUserOrderRateAdmin({
        userOrderRateId,
    }: {
        userOrderRateId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/userorderrates/{userOrderRateId}/approve',
            path: {
                'userOrderRateId': userOrderRateId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserOrderRates`
     * @returns any OK
     * @throws ApiError
     */
    public static hideOutCommentAdmin({
        userOrderRateId,
    }: {
        userOrderRateId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/userorderrates/{userOrderRateId}/hide-out-comment',
            path: {
                'userOrderRateId': userOrderRateId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
